// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"8939b51c","240":"a353b3bd","395":"9e6b5e7e","626":"83fd440b","689":"70c12775","889":"51f4afae","898":"688f8626","978":"e1d47b08"}[chunkId] + ".chunk.js";
};